import { MemberDetailsRowCSSStyle } from './memberdetailsrowcss';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { MemberDetailsRowComponentProps, MemberDetailsRowComponentHandler } from './memberdetailsrowcomponent';
import * as React from 'react';
import { TextComponent } from 'src/com/sixdee/crbtportal/ui/toolkit/text/textcomponent';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { ManageGroupType } from '../managegrouptype';
import { MemberDetailsDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/listtones/memberdetailsdto';
import { UIComponentViewImpl } from 'src/com/sixdee/crbtportal/ui/toolkit/uicomponentview';
import { UIDataModel, UIComponentHandler, UIComponentState } from 'src/com/sixdee/crbtportal/ui/toolkit/uicomponent';
import { MemberTextComponent } from 'src/com/sixdee/crbtportal/ui/toolkit/text/membertext/membertextcomponent';
import './members-details-style.css';

export class MemberDetailsRowViewImpl extends UIComponentViewImpl<UIDataModel>
{
     memberName: TextComponent;
     mobileNumber: TextComponent;

    constructor(context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);
    }

    bindHandlers():void
    {
        this.onAddClicked = this.onAddClicked.bind(this);
        this.onDeleteClicked = this.onDeleteClicked.bind(this);
    }
    
    draw(props: MemberDetailsRowComponentProps, state: UIComponentState, cssStyle: MemberDetailsRowCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);
        console.log("---position: " + props.position);
        console.log("---tytpe: " + props.manageGroupType);
        return (
            <>
            {
                props.manageGroupType !== ManageGroupType.VIEW && props.position === 0 && this.getAddCSS(props, state, cssStyle)
            }
            {
                props.position > 0 && this.getExistingListCSS(props, state, cssStyle)
            }
         </>
        );
    }

    getExistingListCSS(props: MemberDetailsRowComponentProps, state: UIComponentState, cssStyle: MemberDetailsRowCSSStyle)
    {
        return (
            <tr id="members-details-row"> 
            <td id="members-details-name-td">
            <div id="members-details-name-div">
            <MemberTextComponent hint={props.context.getResources().getString(Strings.member_name)} maxLength={this.getUIProps().context.getResources().getString(Strings.member_name_max_length)} label={""} placeholder={props.context.getResources().getString(Strings.member_name)}  isDisabled={props.manageGroupType === ManageGroupType.VIEW ? true :  false} ref={(item: any) => this.memberName = item} id={"#membername"} value={props.memberDetailsDto.getMemberName()} inputType={"text"} isRequired={true}  context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.invalidLength)}/> 
            </div>
            </td>
            <td id="members-details-msisdn-td">
            <div id="members-details-msisdn-div">
             <TextComponent hint={props.context.getResources().getString(Strings.mobilenumberhint)} maxLength={this.getUIProps().context.getResources().getString(Strings.member_number_max_length)} label={""}  placeholder={props.context.getResources().getString(Strings.mobilenumber)}  isDisabled={props.manageGroupType === ManageGroupType.VIEW ? true :  false} ref={(item: any) => this.mobileNumber = item} id={"#mobilenumber"} value={props.memberDetailsDto.getMsisdn()} inputType={"number"} isRequired={true}  context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.invalidLength)}/> 
             </div>
             </td>
             { props.manageGroupType !== ManageGroupType.VIEW && <td id="members-details-button" onClick={this.onDeleteClicked}>
                 <img  id="members-details-add" src={props.context.getResources().getImage("remove_square_pink.svg")}/>
             </td>}
         </tr>  
        );
    }

    getAddCSS(props: MemberDetailsRowComponentProps, state: UIComponentState, cssStyle: MemberDetailsRowCSSStyle)
    {
        return (
            // margin-bottom: 10px; width: 100%; height: 100%; display: flex; flex-flow: row wrap;
            // width: 47.5%; text-align: left; padding-left: 0px; padding-right: 3%;
            // width: 47.9%; text-align: left; padding-left: 0px; padding-right: 3%;
         <tr id="members-details-row"> 
            <td id="members-details-name-td">
            <div  id="members-details-name-div">
            <MemberTextComponent hint={props.context.getResources().getString(Strings.member_name)} maxLength={this.getUIProps().context.getResources().getString(Strings.member_name_max_length)} label={""} placeholder={props.context.getResources().getString(Strings.member_name)}  isDisabled={false} ref={(item: any) => this.memberName = item} id={"#membername"} value={""} inputType={"text"} isRequired={true}  context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.invalidLength)}/> 
            </div>
            </td>
            <td id="members-details-msisdn-td">
            <div  id="members-details-msisdn-div">
             <TextComponent hint={props.context.getResources().getString(Strings.mobilenumberhint)} maxLength={this.getUIProps().context.getResources().getString(Strings.member_number_max_length)} label={""}  placeholder={props.context.getResources().getString(Strings.mobilenumber)}  isDisabled={false} ref={(item: any) => this.mobileNumber = item} id={"#mobilenumber"} value={""} inputType={"number"} isRequired={true}  context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.numberIncorrect)}/> 
             </div>
             </td>
             {props.manageGroupType !== ManageGroupType.VIEW && <td id="members-details-button" onClick={this.onAddClicked}>
                 <img  id="members-details-add" src={props.context.getResources().getImage("add_square_pink.svg")}/>
             </td>}
         </tr>  
        );
    }

    private onAddClicked()
    {
        // if(this.memberName.validate() && this.mobileNumber.validate())
        // {
            let memberDto = (this.getUIProps() as MemberDetailsRowComponentProps).memberDetailsDto as MemberDetailsDtoImpl;
            memberDto.setMemberName(this.memberName.getData());
            memberDto.setMsisdn(this.mobileNumber.getData());
            (this.getUIComponentHandler() as MemberDetailsRowComponentHandler).onAddClicked(memberDto);
        // }
    }

    private onDeleteClicked()
    {
        (this.getUIComponentHandler() as MemberDetailsRowComponentHandler).onDeleteClicked();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/groups/managegroup/membersdetails/memberdetailsrowview.tsx